import React from "react";
import { Textarea } from "../../ui/textarea";
import QuestionFrame from "./QuestionFrame";

/**
 * Multi-line text question.
 *
 * @param {Object} props
 * @param {object} props.question
 * @param {string} [props.value]
 * @param {function(string): void} props.onChange
 * @param {string} [props.error]
 * @param {boolean} [props.readOnly]
 * @returns {JSX.Element}
 */
export default function LongTextQuestion({ question, value = "", onChange, error, readOnly, showRequired }) {
  const fieldId = `survey-q-${question.id}`;
  return (
    <QuestionFrame question={question} error={error} showRequired={showRequired}>
      <Textarea
        id={fieldId}
        value={value || ""}
        placeholder={question.placeholder || ""}
        maxLength={question.maxLength || undefined}
        disabled={readOnly}
        onChange={(e) => onChange(e.target.value)}
        className="min-h-[120px]"
      />
    </QuestionFrame>
  );
}
